/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：693__part-1
 */

"use strict"

import { r } from "./693__part-0"
import * as /* [auto-meaningful-name] */Module_291 from /* 291 */"../291"
function o(e, t) {
  return !t || "object" !== r(t) && "function" !== typeof t ? Module_291.a(e) : t
}
export { o }
